import React, { useContext } from 'react';
import { Field } from 'formik';
import { Row, Col } from 'antd';
import { SelectField, TextField } from 'components/Molecules/FormFields/index';
import { useCreate } from 'context/ResourceProvider/hooks/useCreate';
import T from 'i18n-react';
import classes from '../SubForm.module.scss';
import { FormGenerateGccCpcDoc } from '../../context/FormGenerateGccCpcDoc';

const DocNotifiedBodyInformation = () => {
  const { serviceProviderOptions } = useContext(FormGenerateGccCpcDoc);
  useCreate({
    resource: 'test_items',
  });

  return (
    <Field name="notifiedBodyInformation">
      {() => {
        return (
          <div className={classes.notifiedBodyInformation}>
            <h5 className={classes.title}>Notified Body Information</h5>
            <div className={classes.content}>
              <SelectField
                name="notifiedBodyInformation.serviceProvider"
                label="Name of Notified Body"
                placeholder={T.translate('placeholder.select')}
                options={serviceProviderOptions}
              />
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <TextField
                    name="notifiedBodyInformation.notifiedBodyNumber"
                    placeholder={T.translate('placeholder.fillHere')}
                    label="Notified Body Number"
                  />
                </Col>
                <Col span={12}>
                  <TextField
                    name="notifiedBodyInformation.certificateNumber"
                    placeholder={T.translate('placeholder.fillHere')}
                    label="Certificate Number"
                  />
                </Col>
              </Row>
              <TextField
                name="notifiedBodyInformation.description"
                placeholder={T.translate('placeholder.fillHere')}
                label="Description of Intervention"
              />
            </div>
          </div>
        );
      }}
    </Field>
  );
};

export default DocNotifiedBodyInformation;
